import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about">
      <p>
        hello! i'm giovanna ohl, nice to meet you!
        <br />
        i'm a cinematographer, creative director and editor based in são paulo ⸺
        brazil.
        <br />
        leave a message in one of my contacts below!
      </p>
    </div>
  );
};

export default About;
